import React from 'react';
import hero from "../img/hero.png";
import {Link} from "react-router-dom";

export default function Home({isUser}) {
  return (
    <div className='home'>
        <div className='showcase'>
            <div className='showcase-content'>
                <div className='left'>
                    <p className='small'>PrimeMart Collection</p>
                    <h2>Get up to 30% Off New Arrivals</h2>
                    <Link to = {isUser ? "/shop" : "/login"} className='shop-now'>Shop Now</Link>
                </div>
                <div className='right'><img src = {hero}/></div>
            </div>
        </div>

        <h2 className='heading'>Categories</h2>
        <div className='category'>
            <Link to={isUser ? "/category/clothes" : "/login"}><div className='womens cate'>
                <div>Clothings</div>
            </div></Link>
            <Link to={isUser ? "/category/accessories" : "/login"}><div className='accesories cate'>
                <div>Accessories</div>
            </div></Link>
            <Link to={isUser ? "/category/devices" : "/login"}><div className='devices cate'>
                <div>Devices</div>
            </div></Link>
            <Link to={isUser ? "/category/gaming" : "/login"}><div className='gaming cate'>
                <div>Gaming</div>
            </div></Link>
            <Link to={isUser ? "/category/supermarket" : "/login"}><div className='supermarket cate'>
                <div>Supermarket</div>
            </div></Link>
        </div>
    </div>
  )
}
